import { Form, Select, Input, Row, Col, DatePicker } from 'antd';
import { useSelector } from 'react-redux';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import { BENEFICIADOS } from 'constants/nombresCatalogos';
import { SimpleNumericInput } from 'components';
import PropTypes from 'prop-types';
import { DATE_FORMAT_FORM } from 'utils/date';
import { groupObjectsByProperty } from 'utils/groupObjectsByProperty';

import '../../../../Formulario.scss';

const getTiposAsociacionPorProcesoEspecifico = (
  listaBeneficiadosCompleta,
  procesoEspecificoId
  // catProcesosEspecificos
) => {
  const listaBeneficiados = listaBeneficiadosCompleta.filter(
    (beneficiado) => beneficiado.idProcesoSIMAC === procesoEspecificoId
  );
  const asociaciones = groupObjectsByProperty(listaBeneficiados, 'tipoAsociacion');
  return Object.keys(asociaciones).map((tipoAsociacion) => {
    return {
      tipoAsociacion,
      idTipoAsociacion: asociaciones[tipoAsociacion][0].idTipoAsociacion,
      beneficiarios: asociaciones[tipoAsociacion]
    };
  });
};

const ContestacionSO = ({ form }) => {
  const catBeneficiados = useSelector(selectCatalogByName(BENEFICIADOS));
  const placement = 'topRight';

  // Construir catalogo de sujetos obligados desde el catálogo de beneficiados.
  const catSujetosObligados = [];
  for (let i = 0; i < catBeneficiados.length; i += 1) {
    const objetoABuscar = {
      idSujetoObligado: catBeneficiados[i].idSujetoObligado,
      sujetoObligado: catBeneficiados[i].sujetoObligado
    };
    if (
      !catSujetosObligados.some((item) => JSON.stringify(item) === JSON.stringify(objetoABuscar))
    ) {
      catSujetosObligados.push(objetoABuscar);
    }
  }

  return (
    <div>
      <Form form={form} layout="vertical">
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={6}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) => {
                return prevValues.idProcesoEspecifico !== curValues.idProcesoEspecifico;
              }}>
              {() => {
                const { idProcesoEspecifico } = form.getFieldsValue(['idProcesoEspecifico']);
                // console.log('Contestacion', idProcesoEspecifico, form.getFieldsValue());
                const tiposAsociacionPorProcesoEspecifico = getTiposAsociacionPorProcesoEspecifico(
                  catBeneficiados,
                  idProcesoEspecifico
                );
                return (
                  <Form.Item name="idTipoAsociacion" label="Tipo de asociación:">
                    <Select
                      placeholder="Selecciona..."
                      fieldNames={{
                        value: 'idTipoAsociacion',
                        label: 'tipoAsociacion'
                      }}
                      options={tiposAsociacionPorProcesoEspecifico}
                      filterOption={(inputValue, option) =>
                        option.tipoAsociacion?.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                        -1
                      }
                      showSearch
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item name="idSujetoObligado" label="Sujeto Obligado:">
              <Select
                placeholder="Selecciona..."
                fieldNames={{
                  value: 'idSujetoObligado',
                  label: 'sujetoObligado'
                }}
                options={catSujetosObligados}
                filterOption={(inputValue, option) =>
                  option.sujetoObligado?.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
                showSearch
              />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item name="numeroEscrito" label="Número de escrito:">
              <SimpleNumericInput placeholder="Escribe..." />
            </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item name="fechaEscrito" label="Fecha del escrito:">
              <DatePicker
                onChange={(_e, dateString) => {
                  console.log('date: ', dateString);
                }}
                placement={placement}
                placeholder="Selecciona..."
                format={DATE_FORMAT_FORM}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 0]} className="row-formulario">
          <Col span={12}>
            <Form.Item name="nombreFirmante" label="Nombre de quien firma:">
              <Input placeholder="Escribe..." />
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item name="puesto" label="Puesto:">
              <Input placeholder="Escribe..." />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

ContestacionSO.propTypes = {
  form: PropTypes.shape({ getFieldsValue: PropTypes.func }).isRequired
};

export default ContestacionSO;
